<template>
  <div>
    <IriadeRadioGroup :label="input.label"
                      :options="[{label: 'Oui', value: 'Oui'}, {label: 'Non', value: 'Non'}]"
                      :error-messages="errors"
                      @input="setValue('radio', $event)"
                      v-model="data.radio"></IriadeRadioGroup>
    <div v-if="data.radio === 'Oui'">
      <IriadeTextInput label="Pour quelle raison ?"
                       @input="setValue('raison', $event)"
                       v-model="data.raison"></IriadeTextInput>
      <IriadeTextInput label="Date"
                       type="date"
                       @input="setValue('date', $event)"
                       v-model="date"></IriadeTextInput>
      <IriadeTextInput label="Résultat"
                       @input="setValue('resultat', $event)"
                       v-model="data.resultat"></IriadeTextInput>
    </div>
  </div>
</template>

<script>
  import IriadeFormBlockMixin from './IriadeFormBlockMixin'

  export default {
    mixins: [IriadeFormBlockMixin],

    data () {
      return {
        data: {
          radio: null,
          raison: null,
          date: null,
          resultat: null
        }
      }
    },

    methods: {
      setValue (key, value) {
        this.data[key] = value
        this.$emit('input', this.data)
      }
    },

    mounted () {
      this.$emit('input', this.data)
    }
  }
</script>
